
import { useState, FormEvent } from 'react';

type FormStatus = 'idle' | 'loading' | 'success' | 'error';

export default function ContactForm() {
  const [status, setStatus] = useState<FormStatus>('idle');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const message = (form.elements.namedItem('message') as HTMLTextAreaElement).value;
    if (message.length > 500) return;

    setStatus('loading');

    const data = new URLSearchParams();
    const formData = new FormData(form);
    formData.forEach((value, key) => {
      data.append(key, value as string);
    });

    try {
      const res = await fetch('https://readdy.ai/api/form/d6i12rqf2chgavhbcml0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });

      if (res.ok) {
        setStatus('success');
        form.reset();
        setCharCount(0);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <form
      id="contact-appointment-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="space-y-5"
    >
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-[#1A2332] mb-1">Ad Soyad *</label>
          <input
            type="text"
            name="fullName"
            required
            placeholder="Adınız Soyadınız"
            className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-[#1A2332] placeholder-gray-400 focus:outline-none focus:border-[#00BCD4] transition-colors"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-[#1A2332] mb-1">Telefon *</label>
          <input
            type="tel"
            name="phone"
            required
            placeholder="05XX XXX XX XX"
            className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-[#1A2332] placeholder-gray-400 focus:outline-none focus:border-[#00BCD4] transition-colors"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-[#1A2332] mb-1">E-posta</label>
        <input
          type="email"
          name="email"
          placeholder="ornek@email.com"
          className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-[#1A2332] placeholder-gray-400 focus:outline-none focus:border-[#00BCD4] transition-colors"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-[#1A2332] mb-1">Tekne / Yat Adı</label>
        <input
          type="text"
          name="boatName"
          placeholder="Tekne veya yat adınız"
          className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-[#1A2332] placeholder-gray-400 focus:outline-none focus:border-[#00BCD4] transition-colors"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-[#1A2332] mb-1">Talep Türü *</label>
        <select
          name="requestType"
          required
          className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-[#1A2332] focus:outline-none focus:border-[#00BCD4] transition-colors cursor-pointer"
        >
          <option value="">Seçiniz...</option>
          <option value="Motor Bakım & Onarım">Motor Bakım &amp; Onarım</option>
          <option value="Jeneratör Servisi">Jeneratör Servisi</option>
          <option value="Şaft & Pervane Sistemleri">Şaft &amp; Pervane Sistemleri</option>
          <option value="Deniz Şanzımanı">Deniz Şanzımanı</option>
          <option value="Hidrolik Sistemler">Hidrolik Sistemler</option>
          <option value="Irgat & Vinç Servisi">Irgat &amp; Vinç Servisi</option>
          <option value="Traster Motor Servisi">Traster Motor Servisi</option>
          <option value="Randevu Talebi">Randevu Talebi</option>
          <option value="Diğer">Diğer</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-[#1A2332] mb-1">
          Mesajınız
          <span className={`ml-2 text-xs font-normal ${charCount > 500 ? 'text-red-500' : 'text-gray-400'}`}>
            {charCount}/500
          </span>
        </label>
        <textarea
          name="message"
          rows={4}
          maxLength={500}
          placeholder="Sorununuzu veya randevu talebinizi kısaca açıklayın..."
          onChange={(e) => setCharCount(e.target.value.length)}
          className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-sm text-[#1A2332] placeholder-gray-400 focus:outline-none focus:border-[#00BCD4] transition-colors resize-none"
        />
      </div>

      {status === 'success' && (
        <div className="flex items-center gap-3 bg-green-50 border border-green-200 rounded-lg px-4 py-3">
          <i className="ri-checkbox-circle-fill text-green-500 text-xl flex-shrink-0"></i>
          <p className="text-sm text-green-700 font-medium">Mesajınız iletildi! En kısa sürede sizi arayacağız.</p>
        </div>
      )}

      {status === 'error' && (
        <div className="flex items-center gap-3 bg-red-50 border border-red-200 rounded-lg px-4 py-3">
          <i className="ri-error-warning-fill text-red-500 text-xl flex-shrink-0"></i>
          <p className="text-sm text-red-700 font-medium">Bir hata oluştu. Lütfen tekrar deneyin veya bizi arayın.</p>
        </div>
      )}

      <button
        type="submit"
        disabled={status === 'loading' || charCount > 500}
        className="w-full py-4 bg-[#00BCD4] text-white rounded-lg font-semibold text-sm hover:bg-[#00ACC1] transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
      >
        {status === 'loading' ? (
          <>
            <i className="ri-loader-4-line animate-spin text-lg"></i>
            Gönderiliyor...
          </>
        ) : (
          <>
            <i className="ri-send-plane-fill text-lg"></i>
            Gönder
          </>
        )}
      </button>
    </form>
  );
}
